import { useEffect, useState, useMemo, useCallback } from "react";
import _ from "lodash";

export const useConfirmLeavingPage = (router, shouldConfirm) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const initialLocation = useMemo(() => router.location, []);
    const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false);
    const [nextLocation, setNextLocation] = useState<any>(null);

    useEffect(() => {
        const unListen = router.listen((location) => {
            const isNavigatingAway =
                initialLocation.pathname !== location.pathname || !_.isEqual(initialLocation.query, location.query);
            if (shouldConfirm && !showConfirmationModal && isNavigatingAway) {
                setShowConfirmationModal(true);
                setNextLocation(location);
                router.replace(initialLocation);
            }
        });

        return () => {
            unListen();
        };
    }, [shouldConfirm, router, initialLocation, showConfirmationModal]);

    const handleConfirmationClose = useCallback(() => {
        setShowConfirmationModal(false);
        setNextLocation(null);
    }, []);

    const handleLeavePage = useCallback(() => {
        router.push(nextLocation);
    }, [router, nextLocation]);

    return [showConfirmationModal, handleLeavePage, handleConfirmationClose];
};
